import { useState } from 'react';
import { PencilSimple, X, Plus } from '@phosphor-icons/react';

const VELDEN = [
  ['tav', 'T.a.v. / werf', 'col-span-2'],
  ['straat', 'Straat', 'col-span-2'],
  ['nr', 'Nr', ''],
  ['bus', 'Bus', ''],
  ['postcode', 'Postcode', ''],
  ['stad', 'Gemeente', ''],
  ['land', 'Land', ''],
  ['opmerking', 'Opmerking (bv. losplaats, uren)', 'col-span-2'],
];
const leeg = { tav: '', straat: '', nr: '', bus: '', postcode: '', stad: '', land: 'België', opmerking: '' };

// Klant-default leveradres: bron van waarheid = ingevuld lev_straat (KlantenPage bewaart `zelfde_levadres` niet)
const klantLevAdres = (k) => (k?.lev_straat && String(k.lev_straat).trim())
  ? { tav: k.lev_tav || '', straat: k.lev_straat || '', nr: k.lev_nr || '', bus: k.lev_bus || '', postcode: k.lev_postcode || '', stad: k.lev_stad || '', land: k.lev_land || 'België', opmerking: '' }
  : null;

function AdresRegels({ a }) {
  return (
    <>
      {a.tav && <div className="text-[10px] font-bold text-gray-800">{a.tav}</div>}
      {a.straat && <div className="text-[10px] text-gray-700">{a.straat} {a.nr}{a.bus ? ` bus ${a.bus}` : ''}</div>}
      {(a.postcode || a.stad) && <div className="text-[10px] text-gray-700">{a.postcode} {a.stad}</div>}
      {a.land && <div className="text-[10px] text-gray-700">{a.land}</div>}
      {a.opmerking && <div className="text-[10px] text-gray-500 italic">{a.opmerking}</div>}
    </>
  );
}

// Leveradres in het Klant-blok van het documentformulier.
// value = doc-niveau leveradres (null = geen afwijking → klant-default of factuuradres).
export default function LeverAdresBlok({ klant, value, onChange, readOnly = false }) {
  const [edit, setEdit] = useState(false);
  const [draft, setDraft] = useState(leeg);
  const klantAdres = klantLevAdres(klant);
  const start = () => { setDraft({ ...leeg, ...(value || klantAdres || {}) }); setEdit(true); };
  const ok = () => { if (!draft.straat.trim() && !draft.stad.trim()) return; onChange({ ...draft }); setEdit(false); };

  if (edit) {
    return (
      <div className="mt-2 p-1.5 border-l-[3px] border-red-600 bg-red-50" data-testid="leveradres-form">
        <div className="text-[9px] font-black text-red-600 tracking-wider uppercase mb-1">Leveradres dit document</div>
        <div className="grid grid-cols-2 gap-1">
          {VELDEN.map(([k, lbl, cls]) => (
            <input key={k} className={`field-input text-[10px] py-0.5 px-1 ${cls}`} placeholder={lbl} value={draft[k]}
              onChange={e => setDraft(d => ({ ...d, [k]: e.target.value }))} data-testid={`leveradres-${k}`} />
          ))}
        </div>
        <div className="flex gap-1 mt-1">
          <button type="button" className="btn btn-primary btn-sm text-[10px] py-0.5" onClick={ok} data-testid="leveradres-ok">OK</button>
          <button type="button" className="btn btn-secondary btn-sm text-[10px] py-0.5" onClick={() => setEdit(false)} data-testid="leveradres-annuleer">Annuleer</button>
        </div>
      </div>
    );
  }
  if (value?.straat || value?.stad) {
    return (
      <div className="mt-2 p-1.5 border-l-[3px] border-red-600 bg-red-50" data-testid="klantblok-leveradres">
        <div className="flex items-center justify-between">
          <div className="text-[9px] font-black text-red-600 tracking-wider uppercase">Leveradres · dit document</div>
          {!readOnly && (
            <span className="flex gap-1">
              <button type="button" className="text-gray-500 hover:text-[#002FA7]" onClick={start} title="Leveradres aanpassen" data-testid="leveradres-bewerk"><PencilSimple size={11} /></button>
              <button type="button" className="text-gray-500 hover:text-red-600" onClick={() => onChange(null)} title="Afwijkend leveradres verwijderen" data-testid="leveradres-verwijder"><X size={11} /></button>
            </span>
          )}
        </div>
        <AdresRegels a={value} />
      </div>
    );
  }
  if (klantAdres) {
    return (
      <div className="mt-2 p-1.5 border-l-[3px] border-red-600 bg-red-50" data-testid="klantblok-leveradres">
        <div className="flex items-center justify-between">
          <div className="text-[9px] font-black text-red-600 tracking-wider uppercase">Leveradres</div>
          {!readOnly && <button type="button" className="text-gray-500 hover:text-[#002FA7]" onClick={start} title="Afwijkend leveradres voor dit document" data-testid="leveradres-bewerk"><PencilSimple size={11} /></button>}
        </div>
        <AdresRegels a={klantAdres} />
      </div>
    );
  }
  if (readOnly) return null;
  return (
    <button type="button" className="mt-2 inline-flex items-center gap-1 text-[10px] text-[#002FA7] font-bold hover:underline" onClick={start} data-testid="leveradres-toevoegen">
      <Plus size={10} weight="bold" /> Afwijkend leveradres
    </button>
  );
}
